import { render, staticRenderFns } from "./WordPackageImg.vue?vue&type=template&id=1efd1fb9&scoped=true&"
import script from "./WordPackageImg.vue?vue&type=script&lang=js&"
export * from "./WordPackageImg.vue?vue&type=script&lang=js&"
import style0 from "./WordPackageImg.vue?vue&type=style&index=0&id=1efd1fb9&scoped=true&lang=css&"
import style1 from "./WordPackageImg.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efd1fb9",
  null
  
)

export default component.exports